import { useState } from "react";
import { FormattedMessage } from "react-intl";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";

import {
  Grid2,
  Stack,
  Tooltip,
  IconButton,
  Pagination,
  CircularProgress,
} from "@mui/material";

import {
  LoadingMore,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
} from "components";

import Model from "../Model";
import Filter from "../Filter";
import Delete from "../Delete";
import RequestModel from "../RequestModel";

export default function List({
  page,
  limit,
  total,
  setPage,
  setLimit,

  result,
  refetch,
  loading,

  title,
  isPopup,
  onClose,

  isAssign,
  onAssign,
  assigning,
  multiSelect,

  filter,
  setFilter,
  clearFilter,
  preSelected,
}) {
  const [selected, setSelected] = useState(preSelected || []);
  const [direction, setDirection] = useState("right");

  const handleSelect = (item) => {
    const selectedIndex = selected.map((item) => item.id).indexOf(item.id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (isAssign && !multiSelect && newSelected.length > 0) {
      onAssign(newSelected, onClose);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelected(result);
      return;
    }
    setSelected([]);
  };

  const clearSelection = () => setSelected([]);

  const refresh = () => {
    clearSelection();
    refetch();
  };

  return (
    <>
      <NewDialogTitle title={title} onClose={onClose} isPopup={isPopup} />
      <NewDialogContent isPopup={isPopup}>
        <Stack px={1} flex={2} overflow="scroll" position="relative">
          {/* <Filter
            init={filter}
            setFilter={setFilter}
            clearFilter={clearFilter}
          /> */}
          <Grid2 alignItems="flex-start" container>
            {result.map((model, i) => {
              if (model.node === "request") {
                return (
                  <Grid2
                    key={i}
                    p={0.5}
                    size={{ xs: 12, sm: !isPopup && 6, md: !isPopup && 4 }}
                  >
                    <RequestModel
                      model={model}
                      refetch={refetch}
                      isAssign={isAssign}
                      delay={(i % limit) + 1}
                      checked={
                        selected.find((select) => model.id === select.id)
                          ? true
                          : false
                      }
                      handleSelect={() =>
                        handleSelect({ id: model?.id, title: model.title })
                      }
                    />
                  </Grid2>
                );
              }
              return (
                <Grid2
                  key={i}
                  p={0.5}
                  size={{ xs: 12, sm: !isPopup && 6, md: !isPopup && 4 }}
                >
                  <Model
                    model={model}
                    refetch={refetch}
                    isAssign={isAssign}
                    delay={(i % limit) + 1}
                    checked={
                      selected.find((select) => model.id === select.id)
                        ? true
                        : false
                    }
                    handleSelect={() =>
                      handleSelect({ id: model?.id, title: model.title })
                    }
                  />
                </Grid2>
              );
            })}
            {/* <Grid2 p={0.5} xs={12}>
              <LoadingMore
                total={total}
                loading={loading}
                result={result.length}
                onClick={() => setPage(page + 1)}
              />
            </Grid2> */}
          </Grid2>
        </Stack>
      </NewDialogContent>
      <NewDialogActions isPopup={isPopup}>
        <Stack
          width="100%"
          alignItems="center"
          direction="row-reverse"
          justifyContent="space-between"
        >
          <Stack
            columnGap={0.5}
            alignItems="center"
            direction="row-reverse"
            justifyContent="space-between"
          >
            {/* <TablePagination
              size="small"
              component="div"
              count={100}
              page={page}
              rowsPerPage={limit}
              // onPageChange={handleChangePage}
              onRowsPerPageChange={(e) => setLimit(e.target.value)}
            /> */}
            <Pagination
              size="small"
              page={page}
              count={total}
              // count={Math.round(total / limit)}
              onChange={(e, value) => setPage(value)}
            />
            {loading ? (
              <CircularProgress color="primary" size={25} />
            ) : (
              <Tooltip title={<FormattedMessage id="refresh" />}>
                <IconButton
                  size="small"
                  color="default"
                  onClick={refresh}
                  sx={{ bgcolor: "action.hover" }}
                >
                  <RefreshRoundedIcon color="inherit" fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {/* <Delete
          refetch={refresh}
          selection={selected.length > 0}
          ids={selected.map((item) => item.id)}
        /> */}
          </Stack>
        </Stack>
      </NewDialogActions>
    </>
  );
}
